import { c as _c } from "react/compiler-runtime";
import { memo, useMemo } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import type { VaultV2PendingTimelockDecodedData } from '../../types/pendingTimelocks';
import AddressWithCopyAndExplorer from '../../components/AddressWithCopyAndExplorer';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
type VaultV2SetIsAllocatorPendingData = Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2SetIsAllocatorPendingData';
}>;
interface VaultV2PendingTimelockChangeAllocatorProps {
  functionName: string;
  decodedData: VaultV2SetIsAllocatorPendingData;
}
const VaultV2PendingTimelockChangeAllocator = t0 => {
  const $ = _c(12);
  const {
    functionName,
    decodedData
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    criticality
  } = t1;
  const {
    targetChainId
  } = useWeb3Context();
  let t2;
  bb0: {
    if (!decodedData.isAllocator) {
      t2 = "Remove allocator";
      break bb0;
    }
    t2 = "Add allocator";
  }
  const label = t2;
  let t3;
  if ($[2] !== criticality || $[3] !== label) {
    t3 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[2] = criticality;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-2xs text-foreground">Address</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== decodedData.account.address || $[7] !== targetChainId) {
    t5 = <StyledVaultPendingTimelock.Row>{t4}<AddressWithCopyAndExplorer address={decodedData.account.address} chainId={targetChainId} /></StyledVaultPendingTimelock.Row>;
    $[6] = decodedData.account.address;
    $[7] = targetChainId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex flex-col">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default memo(VaultV2PendingTimelockChangeAllocator);